import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import MerchHeader from './MerchHeader';

class BaseLayout extends Component {
  render() {
    return (
      <>
        {window.location.pathname.substr(1) !== 'sponsors' ? (window.location.pathname.substr(1) === 'merch' ? <MerchHeader/> : <Header/>) : null}

          {this.props.children}
        <Footer />
      </>
    );
  }
}

export default BaseLayout;
